import { render, staticRenderFns } from "./APPDownload.vue?vue&type=template&id=6123ebc4"
import script from "./APPDownload.vue?vue&type=script&lang=js"
export * from "./APPDownload.vue?vue&type=script&lang=js"
import style0 from "./APPDownload.vue?vue&type=style&index=0&id=6123ebc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports